(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["koda-pdp-status-notes"] && !Shopify.designMode) return;
  try {
    if (!window.kodaPdpStatusNotesInitialized) {
    window.kodaPdpStatusNotesInitialized = true;

    document.addEventListener('variant:update', (event) => {
      const html = event.detail?.data?.html;
      if (!html) return;

      document.querySelectorAll('[data-koda-pdp-status-notes]').forEach((current) => {
        const mode = current.getAttribute('data-koda-pdp-status-notes');
        const replacement = html.querySelector(`[data-koda-pdp-status-notes="${mode}"]`);
        if (replacement) current.replaceWith(replacement.cloneNode(true));
        else current.remove();
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
